import React from 'react';
import NumberFormat from 'react-number-format';
import moment from 'moment';
import 'moment-timezone';
import { Typography } from '@material-ui/core';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { SliderValueLabel } from '@mui/material';

// Initialize dayjs plugins
dayjs.extend(utc);
dayjs.extend(timezone);

export const currencyFormat = (value, tableMeta, updateValue) => {
  // if(typeof value !== 'string' || typeof value !== 'number') return value
  return (
    <NumberFormat
      value={parseFloat(value).toFixed(2)}
      thousandSeparator={true}
      prefix={'$'}
      displayType="text"
    />
  );
};

export const currencyTextFormat = (value) => {
  // if(typeof value !== 'string' || typeof value !== 'number') return value
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    maximumFractionDigits: 2, // (causes 2500.99 to be printed as $2,501)
  });
  return formatter.format(value);
};

export const dateTimeFormat = (value, tableMeta, updateValue) => {
  if (!value) return '';
  if (typeof value !== 'string') return value;
  let m = moment(value);
  if (!m.isValid()) return '';
  if (new Date(m).getFullYear() < 1800) return ''
  return <div>{moment.utc(value).format('MM/DD/YYYY hh:mm A')}</div>;
};

export const dateFormat = (value, tableMeta, updateValue) => {
  if (!value) return '';
  if (typeof value !== 'string') return value;
  let m = moment(value);
  if (!m.isValid()) return '';
  if (new Date(m).getFullYear() < 1800) return ''
  return moment.utc(value).format('MM/DD/YYYY');
};

export const dateDayjsFormat = (value, tableMeta, updateValue) => {
  if (!value) return '';
  if (typeof value !== 'string') return value;
  let m = dayjs(value);
  if (!m.isValid()) return '';
  if (new Date(m).getFullYear() < 1800) return ''
  return dayjs.utc(value).format('MM/DD/YYYY');
};

export const dateTimeSecondFormat = (value, tableMeta, updateValue) => {
  if (!value) return '';
  if (typeof value !== 'string') return value;
  let m = moment(value);
  if (!m.isValid()) return '';
  if (new Date(m).getFullYear() < 1800) return ''
  return <div>{moment.utc(value).format('MM/DD/YYYY hh:mm:ss A')}</div>;
};

/**
 * Create timezone-aware date formatters
 * These functions accept a timezone parameter and format dates accordingly
 */

// Timezone-aware date-time formatter (with seconds)
export const createDateTimeSecondFormatter = (timezone = 'America/New_York') => {
  return (value, tableMeta, updateValue) => {
    if (!value) return '';
    if (typeof value !== 'string' && !(value instanceof Date)) return value;
    
    try {
      const m = moment(value);
      if (!m.isValid()) return '';
      if (new Date(m).getFullYear() < 1800) return '';
      
      // Parse the UTC date and convert to timezone
      const utcMoment = moment.utc(value);
      const tzMoment = utcMoment.tz(timezone);
      const formatted = tzMoment.format('MM/DD/YYYY hh:mm:ss A');
      
      return <div>{formatted}</div>;
    } catch (error) {
      console.error('Error formatting date with timezone:', error);
      return <div>{moment.utc(value).format('MM/DD/YYYY hh:mm:ss A')}</div>;
    }
  };
};

// Timezone-aware date-time formatter (without seconds)
export const createDateTimeFormatter = (timezone = 'America/New_York') => {
  return (value, tableMeta, updateValue) => {
    if (!value) return '';
    if (typeof value !== 'string' && !(value instanceof Date)) return value;
    
    try {
      const m = moment(value);
      if (!m.isValid()) return '';
      if (new Date(m).getFullYear() < 1800) return '';
      
      // Convert to specified timezone
      const formatted = moment.utc(value).tz(timezone).format('MM/DD/YYYY hh:mm A');
      return <div>{formatted}</div>;
    } catch (error) {
      console.error('Error formatting date with timezone:', error);
      return <div>{moment.utc(value).format('MM/DD/YYYY hh:mm A')}</div>;
    }
  };
};

// Timezone-aware date formatter (date only, no time)
export const createDateFormatter = (timezone = 'America/New_York') => {
  return (value, tableMeta, updateValue) => {
    if (!value) return '';
    if (typeof value !== 'string' && !(value instanceof Date)) return value;
    
    try {
      const m = moment(value);
      if (!m.isValid()) return '';
      if (new Date(m).getFullYear() < 1800) return '';
      
      // Convert to specified timezone
      return moment.utc(value).tz(timezone).format('MM/DD/YYYY');
    } catch (error) {
      console.error('Error formatting date with timezone:', error);
      return moment.utc(value).format('MM/DD/YYYY');
    }
  };
};
export const noWrapFormat = (value, tableMeta, updateValue) => {
  return (
    <Typography style={{ fontSize: 'inherit' }} noWrap={true}>
      {value}
    </Typography>
  );
};

export const fileSizeFormat = (value, tableMeta, updateValue) => {
  if (!value || value === 0) return '0 Bytes';
  
  const bytes = parseInt(value);
  if (isNaN(bytes)) return value;
  
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};
